
import Vue from 'vue';
import { Trip, TripMutation } from '@clients/myTrips';
import { Component, Prop } from 'vue-property-decorator';
import IconEnd from '@components/icons/trip-details/icon-end.svg';
import TripDataLocationTemplate from "@components/trip-detail/trip-data/TripDataLocationTemplate.vue";

@Component({
  name: 'TripDataEnd',
  components: {
    TripDataLocationTemplate,
    IconEnd
  }
})

export default class TripDataEnd extends Vue {
  $refs!: {
    location: TripDataLocationTemplate
  }

  @Prop({ default: false })
  private addMode: boolean;

  @Prop()
  private trip: Trip;

  @Prop()
  private tripMutation: TripMutation;

  @Prop()
  private prevTrip: Trip;

  @Prop()
  private nextTrip: Trip;

  @Prop({ default: false })
  private loading: boolean;

  get minOdometer() {
    if (this.prevTrip && this.prevTrip.endInfo && this.prevTrip.endInfo.odometer) {
      return this.prevTrip.endInfo.odometer;
    }
    return 0;
  }

  get maxOdometer() {
    if (this.nextTrip && this.nextTrip.startInfo && this.nextTrip.startInfo.odometer) {
      return this.nextTrip.startInfo.odometer;
    }
  }

  get minTimestamp(): Date {
    return (this.prevTrip && this.prevTrip.endInfo && this.prevTrip.endInfo.timestamp) ? new Date(this.prevTrip.endInfo.timestamp) : null;
  }

  get maxTimestamp(): Date {
    return (this.nextTrip && this.nextTrip.startInfo && this.nextTrip.startInfo.timestamp) ? new Date(this.nextTrip.startInfo.timestamp) : new Date();
  }

  public focusField(value: string) {
    this.$refs.location.focusField(value.replace('end-' as string, ''));
  }

  private handleInput(copy: TripMutation) {
    this.$emit('input', copy);
  }

  private emitEdit(value: string) {
    this.$emit('toggleEditMode', 'end-' + value);
  }
}
